import {LastSyncedUpstreamValue} from 'notebook/structured-tables/StructuredTableConstants';
import {Cell} from 'notebook/tables/TableConstants';

export function getUpdatedCellWithLSUV(
  columnProvenanceUuid: string,
  oldCell: Cell,
  lastSyncedUpstreamValues: Array<LastSyncedUpstreamValue> | null | undefined
): Cell {
  const lsuvTypedValue = lastSyncedUpstreamValues?.find(
    (value) => value.columnProvenanceUuid === columnProvenanceUuid
  )?.value;
  return {...oldCell, ...(lsuvTypedValue ? {typedValue: lsuvTypedValue} : {})};
}
